import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner } from 'reactstrap';
import { Entrycameramonitor } from '../../../../api/EntryCameraMonitorifl';
import FaceDetectionsTable from './FaceDetectionsTable';
import './faceDetections.css';

const sampleData = [
  {
    log_id: 16560,
    factory_name: "ytml7_facial",
    employee_id: "ytm7_unknown",
    employee_name: "unknown",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_id: "ytm_150.15.209.58",
    camera_name: "Out",
    camera_position_no: "Gate Out",
    detection_datetime: "2025-07-17 06:54:31",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/Out/2025-07-17/non_sop/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1_065431_001.jpg",
  },
  {
    log_id: 16561,
    factory_name: "ytml7_facial",
    employee_id: "ytm7_unknown",
    employee_name: "unknown",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_position_no: "Gate Out",
    detection_datetime: "2025-07-17 06:54:31",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/Out/2025-07-17/non_sop/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1/ZMQ_SideOnly_5744_20250717_065431_ac89eaa1_065431_001.jpg",
  },
  {
    log_id: 16559,
    employee_id: "ytm7_unknown",
    employee_name: "ali",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_position_no: "Gate In",
    detection_datetime: "2025-07-17 06:54:15",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/In/2025-07-17/ZMQ_Unknown_5730_20250717_065415_17d0f469/ZMQ_Unknown_5730_20250717_065415_17d0f469_065415_001.jpg",
  },
  {
    log_id: 16558,
    employee_id: "Younus",
    employee_name: "unknown",
    blacklisted: false,
    employee_designation: "Intruder",
    camera_position_no: "Gate In",
    detection_datetime: "2025-07-17 06:54:12",
    sop_followed: false,
    face_image_url: "https://storage.googleapis.com/ytml-disruptlabs/person_data/person_data/In/2025-07-17/non_sop/ZMQ_SideOnly_5727_20250717_065412_7b453855/ZMQ_SideOnly_5727_20250717_065412_7b453855_065412_001.jpg",
  },
];

const FaceDetectionsContractTable = ({ statsLoader, unknown_employee, handleImageClick }) => {
  const [livealertsdata, setLivealertsdata] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLivealertsdata(sampleData);
    setLoading(false);

    // When ready to use API:
    fetchFaceDetections();
  }, []);

  const fetchFaceDetections = async () => {
    try {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem('userData'));

      const payload = {
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
        //limit: 100,
        //offset: 0,
        camera_id: "",
        employee_id: "",
        user_type: unknown_employee ? "unknown" : "employee",
        filters: {
          date: "",
          week: "",
          month: "",
          starting: "",
          ending: "",
        },
      };

      const res = await Entrycameramonitor.getAllEmplyoes(payload);
      if (res.status === 200) {
        setLivealertsdata(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching face detections:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="dashboard-first-page">
      <Row className="mb-3">
        <Col>
          <h1 style={{ fontSize: "24px", color: "#1e67d6", fontWeight: "600" }}> Face Detections Table</h1>
        </Col>
      </Row>

      <Row>
        <Col>
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner color="success" style={{ width: "3rem", height: "3rem" }} />
            </div>
          ) : (
            <FaceDetectionsTable handleImageClick={handleImageClick} data={livealertsdata} />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default FaceDetectionsContractTable;
